import React from "react";
import HeroPage from "../ones/PageHero"; // Adjust path based on your file tree
import { 
  MdPieChart, 
  MdTrendingUp, 
  MdAccountBalanceWallet, 
  MdSyncAlt, 
  MdGavel, 
  MdTerminal, 
  MdArrowForward 
} from "react-icons/md";
import CallToAction from "../ones/CallToAction";
import Footer from "../ones/Footer";

export default function AccountingAdvisory() {
  const heroData = {
    kicker: "TRUSTED OVERSIGHT",
    title: "Strategic Accounting Advisory & High-Tier Financial Infrastructure",
    description: "Empowering enterprises with sound financial reporting advice, seamless IFRS implementation, and professional restructuring support to achieve sustainable operational growth."
  };

  const capabilities = [
    {
      icon: <MdPieChart />,
      title: "Financial Reporting Advice",
      desc: "Elite advisory mapping out structural account books, ledger systems, and comprehensive asset monitoring formats that withstand professional audits."
    },
    {
      icon: <MdSyncAlt />,
      title: "IFRS Implementation",
      desc: "Full-scale structural conversion tracking and baseline processing for International Financial Reporting Standards (IFRS) and IFRS for SMEs."
    },
    {
      icon: <MdTrendingUp />,
      title: "IPO Readiness",
      desc: "Corporate governance scaffolding, detailed ledger preparation, and financial health stress testing to prepare high-growth firms for public listings."
    },
    {
      icon: <MdAccountBalanceWallet />,
      title: "Restructuring Support",
      desc: "Hands-on balance sheet analysis and corporate asset restructuring strategies to ensure capital efficiency during mergers or market shifts."
    },
    {
      icon: <MdGavel />,
      title: "Regulatory Compliance",
      desc: "Ongoing support to maintain full operational harmony with NBAA licensing regulations, BRELA requirements, and local business licensing policies."
    }
  ];

  return (
    <div className="service-details-page-wrapper">
      <HeroPage data={heroData} />

      <section className="service-overview-section py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-7" data-aos="fade-right">
              <span className="overview-kicker text-secondary text-uppercase font-weight-bold tracking-wider">Asset Alignment</span>
              <h2 className="overview-title text-primary font-weight-bold mt-2">Precision Accounting Engineered for Operational Growth</h2>
              <p className="overview-paragraph text-muted-narrative mt-3">
                Maintaining orderly accounting files is a primary prerequisite for enterprise resilience. We work closely with internal accountants to organize books, balance sheets, and cash projections while optimizing reporting schedules.
              </p>
            </div>
            <div className="col-lg-5" data-aos="fade-left">
              <div className="overview-sidebar-card border p-4 rounded bg-white shadow-sm">
                <h4 className="text-primary font-weight-bold border-bottom pb-2 mb-3">Service Brief</h4>
                <ul className="sidebar-bullet-list list-unstyled d-flex flex-column gap-2 mb-0">
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>SME &amp; Corporate Formats</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>IFRS Compliance Scaffolding</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>Asset Ledger Streamlining</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-capabilities-section py-5 bg-light-surface-tint">
        <div className="container">
          <div className="section-title-area text-center mb-5" data-aos="fade-up">
            <h2 className="text-primary font-weight-bold">Core Scope of Operations</h2>
            <div className="kicker-line mx-auto bg-secondary mt-2" />
          </div>

          <div className="row g-4 justify-content-center">
            {capabilities.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="premium-capability-card h-100 bg-white p-4 border rounded shadow-sm d-flex flex-column">
                  <div className="capability-icon-box text-primary mb-3 fs-2">{item.icon}</div>
                  <h3 className="capability-title text-primary font-18 font-weight-bold mb-2">{item.title}</h3>
                  <p className="capability-desc text-muted mb-0 font-14 flex-grow-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-cta-banner bg-primary text-white text-center py-5">
        <div className="container py-3" data-aos="zoom-in">
          <h2 className="font-weight-bold mb-3">Optimize Your Financial Infrastructure</h2>
          <p className="max-w-600 mx-auto text-light-opacity mb-4">
            Align your enterprise with clear financial advice and reporting frameworks. Reach out to our advisory team.
          </p>
          <button className="btn btn-secondary text-primary font-weight-bold px-4 py-2 border-0">
            Consult Our Advisors <MdArrowForward className="ms-1" />
          </button>
        </div>
      </section>

    <CallToAction />
    <Footer />
    </div>
  );
}